import { DesktopHeader } from '~/shell/components/DesktopHeader.tsx';
import { MobileHeader } from '~/shell/components/MobileHeader.tsx';
import { cn } from '~/common/utils/styleUtil.ts';
import type { Area } from '~/common/types/area.ts';
import type { IWebshopLoginInfoDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated.ts';
import { Media } from '~/media.ts';
import { WebshopMessageHeader } from '~/features/webshopmessages/components/WebshopMessageHeader';

export interface HeaderProps {
  area: Area;
  loginInfo?: IWebshopLoginInfoDtoData;
  isOciSession?: boolean;
  onMenuClick?: () => void;
  activeNavigation: 'menu' | 'customer' | 'templates' | null;
  onLogoClick: () => void;
  classname?: string;
}

export function Header({
  area,
  loginInfo,
  onMenuClick,
  activeNavigation: navigationView,
  onLogoClick,
  classname,
  isOciSession
}: Readonly<HeaderProps>) {
  return (
    <header
      className={cn(
        'sticky shadow-md top-0 z-50 bg-white desktop:border-gray-300 desktop:w-[calc(100vw-15px)] desktop:left-0',
        classname
      )}
    >
      <WebshopMessageHeader />
      <Media lessThan="desktop">
        <MobileHeader
          isOciSession={isOciSession}
          activeNavigation={navigationView ?? null}
          loginInfo={loginInfo}
          area={area}
          onMenuClick={onMenuClick}
          onLogoClick={onLogoClick}
          className={'z-20'}
        />
      </Media>
      <Media greaterThanOrEqual="desktop">
        <DesktopHeader loginInfo={loginInfo} area={area} isOciSession={isOciSession} />
      </Media>
    </header>
  );
}
